import PropTypes from "prop-types";
import React from "react";

/**
 * An form input that requires clicking on an edit button to enable the input.
 *
 * @example
 *   <ConfirmToEditInput
 *     defaultValue={beacon.uuid}
 *     hasError={false}
 *     id="beacon_uuid"
 *     name="beacon[uuid]"
 *     placeholder="UUID"
 *   />
 */
class ConfirmToEditInput extends React.Component {
  /**
   * Creates the component with the initial state.
   *
   * @param {object} props Initial props
   */
  constructor(props) {
    super(props);
    this.state = { isEnabled: props.hasError };
    this.onEdit = this.onEdit.bind(this);
  }

  /**
   * Enables the input when the edit button is clicked.
   */
  onEdit() {
    this.setState({ isEnabled: true });
  }

  /**
   * Renders the input field with an edit button that enables the input.
   *
   * @returns {object} The React element
   */
  render() {
    if (this.props.hasError) {
      return <div className="field_with_errors">{this.renderInput()}</div>;
    }

    if (this.state.isEnabled) {
      return this.renderInput();
    }

    return (
      <div className="input-group">
        {this.renderInput(true)}
        <span className="input-group-addon" onClick={this.onEdit}>
          <i className="fa fa-pencil" />
        </span>
      </div>
    );
  }

  /**
   * Renders the disabled placeholder input field if the input field hasn't been enabled,
   * and renders either the children or an input field with the props passed in.
   *
   * @param {boolean} disabled Whether the input is disabled
   * @returns {object} The React element
   */
  renderInput(disabled = false) {
    if (this.props.children && !disabled) {
      return this.props.children;
    }

    return (
      <input
        className="form-control"
        defaultValue={this.props.defaultValue}
        disabled={disabled}
        id={this.props.id}
        name={this.props.name}
        placeholder={this.props.placeholder}
        type="text"
      />
    );
  }
}

ConfirmToEditInput.propTypes = {
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  hasError: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string
};

export default ConfirmToEditInput;
